(function() { module.exports = this["rlink_core"]; }());


//////////////////
// WEBPACK FOOTER
// external "rlink_core"
// module id = 2
// module chunks = 0